<template>
  <Teleport to="body">
    <BaseDialog
      :active="state.open"
      :title="state.options?.title || ''"
      :has-footer="true"
      :cancel-text="state.options?.cancelText || 'Cancel'"
      :confirm-text="state.options?.confirmText || 'OK'"
      @close="onCancel"
      @cancel="onCancel"
      @confirm="onConfirm"
    >
      <div class="py-2">
        <div class="flex items-start gap-3">
          <div v-if="state.options?.hasIcon" class="pt-1">
            <i
              class="text-lg"
              :class="iconClass"
              aria-hidden="true"
            ></i>
          </div>
          <div class="text-stone-700 dark:text-stone-300" v-html="safeMessage"></div>
        </div>
      </div>
    </BaseDialog>
  </Teleport>
  
</template>

<script setup>
import { computed } from 'vue';
import BaseDialog from '@/components/shared/BaseDialog.vue';
import { useConfirmBusState, confirm as doConfirm, cancel as doCancel } from '@/services/ui/ConfirmBus.js';

const state = useConfirmBusState();

const iconClass = computed(() => {
  const type = state.options?.type || 'is-info';
  switch (type) {
    case 'is-success':
      return 'fas fa-check-circle text-green-500';
    case 'is-warning':
      return 'fas fa-exclamation-triangle text-yellow-500';
    case 'is-danger':
      return 'fas fa-exclamation-circle text-red-500';
    case 'is-info':
    default:
      return 'fas fa-info-circle text-primary-500';
  }
});

const safeMessage = computed(() => String(state.options?.message || ''));

function onConfirm() { doConfirm(); }
function onCancel() { doCancel(); }
</script>

